/** Minimal audio shape the download gate needs — structurally satisfied by `TAudioSimple`. */
type TCanDownloadAudio = {
    isDownloadable: boolean
    authorUsername: string
    source: { dateUploaded: number }
}

/**
 * Whether the current user may download this audio (port of audio-web `useCanDownloadAudio`): the
 * source must be uploaded, and the audio either public-downloadable or owned by the current user.
 * Compares by username (not id) to avoid the `authorId: string` / session `id: number` mismatch.
 */
export const canDownloadAudio = (audio: TCanDownloadAudio, currentUsername?: string): boolean => {
    const isReadyToDownload = audio.source.dateUploaded > 0
    const isEditor = Boolean(currentUsername) && audio.authorUsername === currentUsername

    return isReadyToDownload && (audio.isDownloadable || isEditor)
}
